// This interface is based on ietf rfc 7807.
// The rfc suggests a standard boiler plate for HTTP errors.
//  https://datatracker.ietf.org/doc/html/rfc7807
export interface IETF_RFC_7807_ERROR {
    type: string
    title: string
    status: number
    detail: string
    instance: string
}

// API-specific exception details.
interface ExceptionDetails {
    message: string
    type: string
    raw: string
    stackFrames: StackFrame[]
}
interface StackFrame {
    filePath?: string
    fileName?: string
    function?: string
    line?: number
    preContextLine?: number
    preContextCode?: string
    contextCode?: string
    postContextCode?: string
}

export interface ApiError extends IETF_RFC_7807_ERROR {
    traceId: string
    errors?: Record<string, Array<string>>
    exceptionDetails?: Array<ExceptionDetails>
}

// Extend error to classify as a generic error when required.
export default class ResponseError extends Error {
    get traceId() {
        return this.error.traceId ?? ''
    }

    get errors() {
        return this.error.errors ?? {}
    }

    get exceptionDetails() {
        return this.error.exceptionDetails ?? []
    }

    get type() {
        return this.error.type ?? ''
    }

    get title() {
        return this.error.title ?? ''
    }

    get status() {
        return this.error.status ?? 0
    }

    get detail() {
        return this.error.detail ?? ''
    }

    get instance() {
        return this.error.instance ?? ''
    }

    // Override Error.message to return the detail field of the RFC 7807 model.
    get message() {
        return this.detail
    }

    constructor(private error: ApiError) {
        super()
        this.error = error ?? {}
    }

    toString() {
        if (this.status === 400 && this.title.includes('validation error')) {
            let errors = this.title + '\n'
            for (const field in this.errors) {
                const message = this.errors[field]
                errors += `${field}: ${message}\n`
            }
            return errors
        }

        return this.detail || this.title || 'Unknown error'
    }
}
